const chargingTransactionsErrorEnum = {
    ConnectorStatusNotAllowed: -1,
    FailedChargeConceptLimit: -2,
    FailedStartTransactionOnRemote: -3,
    ChargePointStatusUnavailable: -4,
    // Spec 000304 (Q7) - the company turned the landing-page module off.
    CompanyNotActive: -5,
    FailedConnectWithRemoteServer: -999,
  };
  
  export default chargingTransactionsErrorEnum;
  